const VehicleConditionValues = {
    NEW: 'new',
    USED: 'used',
    DEMO: 'demo',
};

export default VehicleConditionValues;
